import { cn } from "@/shared/lib/utils"

/** Shared easing for sidebar width / inset animations. */
export const SIDEBAR_LAYOUT_EASE = "ease-[cubic-bezier(0.22,1,0.36,1)]" as const

export const SIDEBAR_WIDTH_TRANSITION = cn(
  "transition-[width] duration-500 motion-reduce:transition-none",
  SIDEBAR_LAYOUT_EASE
)

export const SIDEBAR_INSET_TRANSITION = cn(
  "transition-[margin-left] duration-500 motion-reduce:transition-none",
  SIDEBAR_LAYOUT_EASE
)

export const SIDEBAR_REVEAL_TRANSITION = cn(
  "transition-[opacity,max-width] duration-500 motion-reduce:transition-none",
  SIDEBAR_LAYOUT_EASE
)
